import React from "react";
import {withStyles} from "material-ui/styles/index";
import {connect} from "react-redux";
import {compose} from "recompose";
import styles from "./BatteryStatementStyles";
import BatteryStatementEn from "./BatteryStatementEn";
import BatteryStatementFr from "./BatteryStatementFr";
import BatteryStatementDe from "./BatteryStatementDe";

class BatteryStatement extends React.Component {
  constructor(props) {
    super(props);
  }

  renderBatteryStatement(activeLanguage) {
    if (activeLanguage === "fr-FR") {
      return <BatteryStatementFr/>
    } else if (activeLanguage === "de-DE") {
        return <BatteryStatementDe />
    } else {
      return <BatteryStatementEn/>;
    }
  }

  render() {
    const {activeLanguage} = this.props;

    console.log("activeLanguage: ", activeLanguage);

    return <>
      {this.renderBatteryStatement(activeLanguage)}
    </>;
  }
}

const mapStateToProps = state => ({
  activeLanguage: state.languageReducer.selectedLanguage,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(BatteryStatement);
